<template>
  <div class="filings">
    <p>
      Copyright ©
      {{ serverYear }}
      山东豸信认证服务有限公司版权所有.<br />鲁ICP备15043318号.鲁公网安备37011202001700号
    </p>
    <p>公司地址：山东省济南市历城区唐冶绿地汇中心23号楼101</p>
    <p>
      <svg-icon
        icon-class="sidebar-email"
        class="email-icon"
        @click="handleAddressClick"
      />service@zxca.cn
    </p>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'networkSecurity',
  data() {
    return {
      serverYear: new Date().getFullYear(),
      clickCount: 0
    }
  },
  methods: {
    /** 连续点击5次跳转到 iframeDemo 页面 */
    handleAddressClick() {
      this.clickCount++
      if (this.clickCount >= 5) {
        this.clickCount = 0
        this.$router.push('/iframeDemo')
      }
    }
  },
  created() {
    axios
      .head(window.location.href + '?_=' + new Date().getTime())
      .then((res) => {
        const serverTime = new Date(res.headers.date).getFullYear() // 服务器时间
        this.serverYear = serverTime
      })
  }
}
</script>

<style lang="scss" scoped>
.filings {
  padding-top: 0.4rem;
  padding-bottom: 0.9rem;
  margin-bottom: 1.1rem;
  text-align: center;
  p {
    font-size: 0.24rem;
    font-weight: 400;
    color: #243c56;
    line-height: 0.4rem;
    margin-bottom: 0.24rem;
    &:first-child {
      color: #293c54;
      line-height: 0.36rem;
    }
    &:last-child {
      margin-bottom: 0;
      color: #748394;
    }
  }
  span {
    margin-right: 0.24rem;
  }
  .email-icon {
    margin-right: 0.18rem;
  }
}
</style>
